/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  Replicas,
  Replicas$inboundSchema,
  Replicas$Outbound,
  Replicas$outboundSchema,
} from "./replicas.js";

/**
 * Replica bounds for a single region the environment deploys to.
 */
export type EnvironmentRegion = {
  /**
   * Region name, such as us-east-1.
   */
  name: string;
  /**
   * Min and max replica bounds for autoscaling in a region.
   */
  replicas: Replicas;
};

/** @internal */
export const EnvironmentRegion$inboundSchema: z.ZodType<
  EnvironmentRegion,
  z.ZodTypeDef,
  unknown
> = z.object({
  name: z.string(),
  replicas: Replicas$inboundSchema,
});
/** @internal */
export type EnvironmentRegion$Outbound = {
  name: string;
  replicas: Replicas$Outbound;
};

/** @internal */
export const EnvironmentRegion$outboundSchema: z.ZodType<
  EnvironmentRegion$Outbound,
  z.ZodTypeDef,
  EnvironmentRegion
> = z.object({
  name: z.string(),
  replicas: Replicas$outboundSchema,
});

export function environmentRegionToJSON(
  environmentRegion: EnvironmentRegion,
): string {
  return JSON.stringify(
    EnvironmentRegion$outboundSchema.parse(environmentRegion),
  );
}
export function environmentRegionFromJSON(
  jsonString: string,
): SafeParseResult<EnvironmentRegion, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EnvironmentRegion$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EnvironmentRegion' from JSON`,
  );
}
